// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableSkeleton_tableContainer__lhFcG","table":"TableSkeleton_table__ksc4L","skeleton":"TableSkeleton_skeleton__cxVQr","shimmer":"TableSkeleton_shimmer__718nK"};